export enum DeviceStatus {
    None = 'none',
    Processing = 'processing',
    Registered = 'registered',
    Error = 'error',
    Deactivated = 'deactivated'
}
